import React, {useState} from "react";
import '../../../styles/components/onboarding/info/info-page.scss';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import WelcomePage from "./WelcomePage";
import SongsPage from "./SongsPage";
import FeedbackPage from "./FeedbackPage";
import StepsPage from "./StepsPage";
import "swiper/css/pagination";
import InfoNavigation from "./InfoNavigation";
import {navigate} from "../../../services/navigation/navigation";
import {appPagePaths} from "../../../config/config";
import {Swiper as SwiperCore } from "swiper";
import {useTrialNavigation} from "../../../hooks/trialNavigation.hook";

export default function InfoPage() {
  const [swiper, setSwiper] = useState<SwiperCore>();
  const [index, setIndex] = useState(0);
  const {navigateToAppropriateAccountCreationPage} = useTrialNavigation();

  return (
    <div className="info-page">
      <Swiper
        width={null}
        onSwiper={s => {
          setSwiper(s);
        }} onActiveIndexChange={(s) => {
          setIndex(s.activeIndex);
        }}
      >
        <SwiperSlide><WelcomePage/></SwiperSlide>
        <SwiperSlide><SongsPage/></SwiperSlide>
        <SwiperSlide><FeedbackPage/></SwiperSlide>
        <SwiperSlide><StepsPage/></SwiperSlide>
      </Swiper>
      <InfoNavigation currentIndex={index} onNextClick={()=>{
        if (swiper && !swiper.isEnd) {
          swiper.slideNext();
        } else {
          navigateToAppropriateAccountCreationPage();
        }
      }}/>
    </div>
  );
}
